/**
 * Datasheet columns — Access form `frmMatchingPSMatch_Stock_Sales_dts` (22 cột).
 * Bám đúng spec §6 trong `frmMatchingPSMatch_Stock_Sales_AI_Web_Conversion_Spec.md`.
 *
 * Shape theo skill `table-style` — ColumnDef + filter kind hint:
 *   - `match_id` checkbox (Allocation ID hữu hạn)
 *   - `s_side`, `s_warehouse`, `s_client`, `s_quality`, `stack_side`, `stack_warehouse`,
 *     `person_updated` checkbox (distinct value thường nhỏ)
 *   - Còn lại text / number / date theo `kind`.
 */
import type { ColumnFilterKind } from '@/components/dataList'

export type StockSalesDatasheetRow = {
  id: string | number
  match_id?: number | string | null
  match_date?: string | Date | null
  match_kg?: number | string | null
  s_side?: string | null
  s_warehouse?: string | null
  s_client?: string | null
  s_quantity?: number | string | null
  s_quality?: string | null
  s_ps_matched?: number | string | null
  s_instructed_all?: number | string | null
  s_un_quantity_all?: number | string | null
  s_can_allocated?: number | string | null
  s_allocated?: number | string | null
  s_unallocated?: number | string | null
  stack_side?: string | null
  stack_warehouse?: string | null
  stack_can_allocate?: number | string | null
  stack_allocated?: number | string | null
  stack_unallocated?: number | string | null
  note?: string | null
  date_updated?: string | Date | null
  person_updated?: string | null
}

export type StockSalesColumnKind = 'text' | 'date' | 'datetime' | 'number' | 'percent'

export type StockSalesColumnDef = {
  key: keyof StockSalesDatasheetRow
  label: string
  kind?: StockSalesColumnKind
  align?: 'right'
  filter?: ColumnFilterKind
  width?: number
}

export const STOCK_SALES_COLUMNS: StockSalesColumnDef[] = [
  { key: 'match_id', label: 'Allocated ID', kind: 'number', align: 'right', width: 110 },
  { key: 'match_date', label: 'Date', kind: 'date', width: 110 },
  { key: 'match_kg', label: 'Allocated KG', kind: 'number', align: 'right', width: 120 },
  { key: 'stack_side', label: 'Stack - Side', filter: 'checkboxes', width: 130 },
  { key: 'stack_warehouse', label: 'Stack - Warehouse', filter: 'checkboxes', width: 150 },
  { key: 'stack_can_allocate', label: 'Stack - Can Allocate', kind: 'number', align: 'right', width: 160 },
  { key: 'stack_allocated', label: 'Stack - Sales Allocated', kind: 'number', align: 'right', width: 180 },
  { key: 'stack_unallocated', label: 'Stack - Sales Unallocated', kind: 'number', align: 'right', width: 190 },
  { key: 's_allocated', label: 'S - Stock Allocated (Warehouse)', kind: 'number', align: 'right', width: 220 },
  { key: 's_side', label: 'S - Side', filter: 'checkboxes', width: 130 },
  {
    key: 's_un_quantity_all',
    label: 'S - Unmatched - Uninstruced (All)',
    kind: 'number',
    align: 'right',
    width: 220,
  },
  { key: 's_can_allocated', label: 'S - Instructed (Warehouse)', kind: 'number', align: 'right', width: 200 },
  { key: 's_unallocated', label: 'S - Unmatched (Warehouse)', kind: 'number', align: 'right', width: 200 },
  { key: 's_warehouse', label: 'S - Warehouse', filter: 'checkboxes', width: 140 },
  { key: 's_client', label: 'S - Client', filter: 'checkboxes', width: 140 },
  { key: 's_quantity', label: 'S - Quantity', kind: 'number', align: 'right', width: 120 },
  { key: 's_quality', label: 'S - Quality', filter: 'checkboxes', width: 110 },
  { key: 's_ps_matched', label: 'S - PS Matched', kind: 'number', align: 'right', width: 130 },
  { key: 's_instructed_all', label: 'S - Instructed (All)', kind: 'number', align: 'right', width: 150 },
  { key: 'note', label: 'Note', width: 180 },
  { key: 'date_updated', label: 'Updated Date', kind: 'datetime', width: 160 },
  { key: 'person_updated', label: 'Updated Person', filter: 'checkboxes', width: 150 },
]
